import { render } from "./InfocenterMenu.vue?vue&type=template&id=90d3a14c"
import script from "./InfocenterMenu.vue?vue&type=script&lang=js"
export * from "./InfocenterMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__